export default __webpack_public_path__ + "static/media/comment_small.45a2cb54.png";